import { Log, LogStatus } from '@/types/logs'

import styles from './Unfinished.module.scss'

interface Props {
    log: Log
}

export const Unfinished = ({ log }: Props) => {
    if (log.status !== LogStatus.Incomplete) return null

    return (
        <div className={styles.root}>
            <span className={styles.unfinished}>Unfinished</span>
        </div>
    )
}
